import { useRef, useState, useImperativeHandle, useEffect, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { Fade } from '@material-ui/core';
import { PopupV2 as AnimatedPopup } from '../Popup';
import { FadeInAndOutDuration, IPopup } from '../../../constants/commonPortal.constant';

const portalElement = document.getElementById('portal');

const Snackbar = forwardRef((_, ref) => {
  const timerRef = useRef(0);
  const [popup, setPopup] = useState(IPopup({}));

  const handleFSPopupClose = () => {
    setPopup(IPopup({}));
  };

  const handleFSPopupOpen = (_popup = IPopup({})) => {
    setPopup(_popup);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // timerRef.current = setTimeout(handleFSPopupClose, _popup.timeout);
  };

  useImperativeHandle(ref, () => ({
    handleFSPopupClose,
    handleFSPopupOpen,
  }));

  useEffect(() => {
    return () => {
      if (timerRef.current) { clearTimeout(timerRef.current); }
    };
  }, []);

  const VisibilityClass = new Map([
    [true, ''],
    [false, 'visibility-hidden'],
  ]);

  return (
    createPortal(
      <div className={`common-fspopup-container flex flex-fill align-items-center justify-content-center width-full height-100vh fixed ${VisibilityClass.get(popup.open)}`}>
        <Fade in={popup.open} timeout={FadeInAndOutDuration}>
          <div className='flex flex-fill align-items-center justify-content-center width-full height-100vh relative'>
            <AnimatedPopup popup={popup} />
          </div>
        </Fade>
      </div>,
      portalElement,
    )
  );
});

export default Snackbar;
